<template>
  <div>
    <div class="notice-bar">特别提醒：各专业复习资料包括公共科目和专业综合，请按需购买。</div>
    <el-table :data="goodsList" style="width:100%" size="small" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="image" label="封面" width="80" align="center">
        <template slot-scope="scope">
          <img v-if="scope.row.image" :src="scope.row.image" style="width:50px;height:50px;object-fit:cover;border-radius:4px;" />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="书名" min-width="200"></el-table-column>
      <el-table-column prop="price" label="单价（元）" width="120" align="center">
        <template slot-scope="scope"><span style="color:#f56c6c;font-weight:600;">¥{{ scope.row.price }}</span></template>
      </el-table-column>
      <el-table-column label="选购" width="80" align="center">
        <template slot-scope="scope">
          <el-checkbox
            :disabled="scope.row.is_must === 1"
            :value="selectedIds.indexOf(scope.row.id) > -1"
            @change="toggleSelect(scope.row)"
          ></el-checkbox>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrap" v-if="total > pageSize">
      <el-pagination background layout="prev, pager, next" :page-size="pageSize"
        :total="total" :current-page.sync="page" @current-change="getGoodsList"></el-pagination>
    </div>
    <div v-if="goodsList.length === 0 && !loading" class="empty-tip">暂无可购买书籍</div>

    <!-- 已选书籍清单 -->
    <div class="cart-section" v-if="selectedIds.length > 0">
      <div class="section-title">已选书籍（{{ selectedIds.length }}本）</div>
      <div class="cart-list">
        <div class="cart-item" v-for="id in selectedIds" :key="id">
          <span class="cart-book-title">{{ selectedMap[id] ? selectedMap[id].title : id }}</span>
          <span class="cart-book-price" v-if="selectedMap[id]">¥{{ selectedMap[id].price }}</span>
          <el-button type="text" size="mini" class="cart-remove"
            v-if="!selectedMap[id] || selectedMap[id].is_must !== 1"
            @click="removeSelect(id)"><i class="el-icon-close"></i></el-button>
          <el-tag size="mini" type="info" v-else>必选</el-tag>
        </div>
      </div>
      <div class="cart-total">合计：<span class="cart-total-price">¥{{ selectedTotal }}</span></div>
    </div>

    <!-- 收货信息 -->
    <div class="ship-section" v-if="goodsList.length > 0">
      <div class="section-title">收货信息</div>
      <el-form :model="shipForm" :rules="shipRules" ref="shipForm" label-width="90px" size="small" style="max-width:500px;">
        <el-form-item label="收货人" prop="ship_username">
          <el-input v-model="shipForm.ship_username" placeholder="请输入收货人姓名"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="ship_mobile">
          <el-input v-model="shipForm.ship_mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="ship_address">
          <el-input v-model="shipForm.ship_address" placeholder="请输入详细收货地址"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="submit-wrap" v-if="goodsList.length > 0">
      <el-button type="danger" @click="goPayBooks()">确认收货地址并支付</el-button>
    </div>

    <el-dialog title="是否已完成支付" :visible.sync="payDialogVisible" width="400px" center>
      <span>请在打开的页面中完成支付</span>
      <span slot="footer">
        <el-button @click="payDialogVisible = false">取消支付</el-button>
        <el-button type="primary" @click="checkPayResults()">已完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reqGoodsList, reqCreateGoodsOrder, orderDetails } from "@/api";
export default {
  data() {
    return {
      loading: false,
      goodsList: [],
      selectedIds: [],
      selectedMap: {},
      total: 0,
      page: 1,
      pageSize: 10,
      shipForm: { ship_username: "", ship_mobile: "", ship_address: "" },
      shipRules: {
        ship_username: [{ required: true, message: "请输入收货人姓名", trigger: "blur" }],
        ship_mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" },
        ],
        ship_address: [{ required: true, message: "请输入收货地址", trigger: "blur" }],
      },
      payDialogVisible: false,
      order: {},
    };
  },
  methods: {
    getGoodsList() {
      this.loading = true;
      reqGoodsList({ page: this.page, limit: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.data.code === 1) {
          this.goodsList = res.data.data.list || [];
          this.total = res.data.data.total || 0;
          // 缓存书籍信息并自动选中必选项
          this.goodsList.forEach((item) => {
            this.$set(this.selectedMap, item.id, { title: item.title, price: item.price, is_must: item.is_must });
            if (item.is_must === 1 && this.selectedIds.indexOf(item.id) === -1) {
              this.selectedIds.push(item.id);
            }
          });
        }
      }).catch(() => { this.loading = false; });
    },
    toggleSelect(row) {
      var idx = this.selectedIds.indexOf(row.id);
      if (idx > -1) { this.selectedIds.splice(idx, 1); }
      else {
        this.selectedIds.push(row.id);
        this.$set(this.selectedMap, row.id, { title: row.title, price: row.price, is_must: row.is_must });
      }
    },
    removeSelect(id) {
      var idx = this.selectedIds.indexOf(id);
      if (idx > -1) this.selectedIds.splice(idx, 1);
    },
    goPayBooks() {
      if (this.selectedIds.length === 0) return this.$message.warning("请至少选择一本书籍");
      this.$refs.shipForm.validate((valid) => {
        if (!valid) return;
        reqCreateGoodsOrder({
          goods_ids: this.selectedIds,
          ship_username: this.shipForm.ship_username,
          ship_mobile: this.shipForm.ship_mobile,
          ship_address: this.shipForm.ship_address,
        }).then((res) => {
          if (res.data.code === 1) {
            this.order = res.data.data.order;
            window.open(res.data.data.pay_url);
            this.payDialogVisible = true;
          } else { this.$message.error(res.data.msg); }
        });
      });
    },
    checkPayResults() {
      orderDetails({ id: this.order.id }).then((res) => {
        if (res.data.code === 1 && res.data.data.pay_switch == 1) {
          this.payDialogVisible = false;
          this.$message.success("支付成功");
          this.$parent.reload();
        }
      });
    },
  },
  computed: {
    selectedTotal() {
      var sum = 0;
      this.selectedIds.forEach((id) => {
        if (this.selectedMap[id]) sum += parseFloat(this.selectedMap[id].price) || 0;
      });
      return sum.toFixed(2);
    },
  },
  mounted() { this.getGoodsList(); },
};
</script>

<style scoped>
.notice-bar { background: #fef0f0; color: #f56c6c; font-size: 14px; font-weight: 600; padding: 10px 16px; border-radius: 4px; margin-bottom: 16px; }
.pagination-wrap { text-align: center; margin-top: 16px; }
.empty-tip { text-align: center; color: #999; padding: 40px 0; font-size: 14px; }
.ship-section { margin-top: 24px; padding-top: 20px; border-top: 1px solid #eee; }
.section-title { font-size: 15px; font-weight: 600; color: #303133; margin-bottom: 16px; }
.cart-section { margin-top: 24px; padding: 16px; background: #fafafa; border-radius: 6px; border: 1px solid #eee; }
.cart-list { display: flex; flex-wrap: wrap; gap: 8px; }
.cart-item { display: inline-flex; align-items: center; gap: 6px; background: #fff; border: 1px solid #e8e8e8; border-radius: 4px; padding: 6px 10px; font-size: 13px; }
.cart-book-title { color: #303133; }
.cart-book-price { color: #f56c6c; font-weight: 600; }
.cart-remove { color: #999; padding: 0; font-size: 14px; }
.cart-remove:hover { color: #f56c6c; }
.cart-total { margin-top: 12px; text-align: right; font-size: 14px; color: #606266; }
.cart-total-price { color: #f56c6c; font-size: 18px; font-weight: 600; }
.submit-wrap { text-align: center; margin-top: 24px; }
.selected-tip { color: #f56c6c; font-size: 14px; margin-right: 12px; }
</style>
